import { useEffect, useState } from "react";

import axios from "axios";

import schema from "../schema";
import { DOMAIN } from "config/config";

import Formizo from "Components/LabIZO/Formizo";
import { Accessor, Env, ErrorX, store, ColorX } from "static";
import { VStack, HStack, Spacer } from "Components/LabIZO/Stackizo";

const SysGeneral = () => {
  const [sysinfo, setSysinfo] = useState(null);
  const getSysInfo = async () => {
    let payloadOut = {
      JWT: store.user.JWT,
    };

    try {
      const { data } = await axios.post(`${DOMAIN}/Config/System/Info`, payloadOut);
      if (!data.Success) ErrorX.Handle(data);
      setSysinfo(data.payload);
    } catch (e) {
      store.Alert("Cannot get system info", "error");
    }
  };
  useEffect(() => {
    getSysInfo();
  }, []);

  const onSubmit = async (data: any) => {
    let link = "/Config/System/Edit";
    let url = DOMAIN + link;
    let payloadOut = {
      data: {
        ...data,
      },
      JWT: store.user.JWT,
    };

    try {
      console.log(link, payloadOut);

      store.isLoading(true);
      let { data } = await axios.post(url, payloadOut);
      await getSysInfo();
      store.isLoading(false);
      console.log(link, data);
      if (!data.Success) {
        ErrorX.Handle(data.payload);
        return;
      }

      //updon success
      store.Alert("System Config updated successfully", "success");
      await Env.GetSysInfo();
    } catch (e) {
      store.Alert("Cannot set system config", "error");
    }
  };

  const renderLanguageSetting = () => {
    return (
      <Formizo
        //
        schema={schema.general}
        buttons={["Revert", "Submit"]}
        onSubmit={onSubmit}
        defaultValue={sysinfo}
      />
    );
  };

  return (
    <HStack justifyContent="flex-start" height="100%" gap={3} paddingX={4}>
      <VStack width="100%">{renderLanguageSetting()}</VStack>
    </HStack>
  );
};
export default SysGeneral;
